import TextField from "@carrier-io/air-react/TextField";
import React from "react";
import { Control, Controller } from "react-hook-form";
import Autocomplete from "@carrier-io/air-react/Autocomplete";

type ControllableAutocompleteProps = {
  name: string;
  control: Control<{ [key: string]: string }>;
  options: Array<{ label: string; value: string }> | Array<string>;
  error?: string;
  textFieldProps?: React.ComponentProps<typeof TextField> & {
    "data-testid"?: string;
  };
} & Omit<
  React.ComponentProps<typeof Autocomplete>,
  "renderInput" | "options" | "error"
>;

export const ControllableAutocomplete = ({
  key,
  control,
  name,
  error,
  textFieldProps,
  ...props
}: ControllableAutocompleteProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { name, onChange, value, ref, onBlur },
        formState: { defaultValues },
      }) => (
        <Autocomplete
          key={key}
          ref={ref}
          value={value}
          defaultValue={defaultValues?.[name] ?? ""}
          onChange={(_, value) => {
            onChange(value);
          }}
          onBlur={onBlur}
          renderInput={(params) => (
            <TextField
              {...params}
              {...textFieldProps}
              {...(textFieldProps?.required && {
                // Cannot work together with react-hook-form
                required: false,
                label: `${textFieldProps?.label} *`,
              })}
              error={!!error}
              helperText={error}
              data-testid={textFieldProps?.["data-testid"]}
            />
          )}
          {...props}
        />
      )}
    />
  );
};
